import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import React from 'react';
import { Typography, Colors } from '@zapier/design-system';
import { Checkbox as Checkbox$1 } from 'react-aria-components';

const checkboxStyles = css`
  .label {
    ${Typography.Body1}
    padding-left: var(--zds-space-4, 4px);
  }

  display: flex;
  align-items: center;
  gap: var(--zds-space-4, 4px);
  color: var(--zds-gray-warm-10, ${Colors.GrayWarm10});
  forced-color-adjust: none;
  padding-left: 3px;

  .checkbox {
    width: 18px;
    height: 18px;
    border: 2px solid var(--zds-stroke-default, ${Colors.GrayWarm6});
    border-radius: var(--zds-radius-none, 3px);
    transition: all 40ms;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 14px;
    height: 14px;
    fill: none;
    stroke: var(--zds-prime-white, ${Colors.PrimeWhite});
    stroke-width: 3px;
    stroke-dasharray: 22px;
    stroke-dashoffset: 66;
    transition: all 120ms;
  }

  &[data-has-no-visible-label] {
    padding: 0;
  }

  &[data-pressed] .checkbox {
    border-color: var(--zds-ui-primary-stronger, ${Colors.BrandNight});
  }

  &[data-focus-visible] {
    outline: var(--zds-border-focus, 2px solid ${Colors.UiPrimaryStrongest});
    outline-offset: var(--zds-size-2, 3px);
  }

  &[data-selected],
  &[data-indeterminate] {
    .checkbox {
      border-color: var(
        --zds-ui-primary-stronger,
        ${Colors.UiPrimaryStrongest}
      );
      background: var(--zds-ui-primary-stronger, ${Colors.UiPrimaryStrongest});
    }

    &[data-pressed] .checkbox {
      border-color: var(--zds-ui-primary-strongest, ${Colors.BrandNight});
      background: var(--zds-ui-primary-strongest, ${Colors.BrandNight});
    }

    .label {
      ${Typography.Body3}
    }

    svg {
      stroke-dashoffset: 44;
    }
  }

  &[data-invalid] {
    color: var(--zds-status-error-stronger, ${Colors.StatusErrorWeaker});

    .checkbox {
      border-color: var(
        --zds-status-error-stronger,
        ${Colors.StatusErrorWeaker}
      );
    }

    &[data-selected] .checkbox {
      background: var(--zds-status-error-stronger, ${Colors.StatusErrorWeaker});
    }

    &[data-pressed][data-selected] .checkbox {
      background: var(
        --zds-status-error-strongest,
        ${Colors.StatusErrorWeaker}
      );
      border-color: var(
        --zds-status-error-strongest,
        ${Colors.StatusErrorWeaker}
      );
    }

    &[data-pressed]:not([data-selected]) .checkbox {
      border-color: var(
        --zds-status-error-strongest,
        ${Colors.StatusErrorWeaker}
      );
    }

    &[data-selected] svg {
      stroke-dashoffset: 44;
    }
  }

  &[data-disabled] {
    color: var(--zds-text-weaker, ${Colors.GrayWarm5});
    cursor: not-allowed;
    background: var(--zds-background-stronger, transparent);

    .checkbox {
      background: var(--zds-background-stronger, ${Colors.GrayWarm3});
    }

    &:not([data-indeterminate='true']) svg {
      width: 12px;
      height: 12px;
      stroke: var(--zds-stroke-default, ${Colors.GrayWarm5}) !important;
    }

    .checkbox {
      border-color: var(--zds-stroke-default, ${Colors.GrayWarm5});
    }

    &[data-has-no-visible-label] {
      background: none;

      .checkbox {
        background: var(--zds-background-stronger, ${Colors.GrayWarm3});
      }
    }
  }

  &[data-indeterminate] {
    &[data-invalid] .checkbox {
      background: var(--zds-status-error-stronger, ${Colors.StatusErrorWeaker});
    }

    &[data-disabled] .checkbox {
      background: var(--zds-gray-warm-5, ${Colors.GrayWarm5});
    }

    & svg {
      transition: none;
      stroke: none;
      top: 0px;
      fill: var(--zds-prime-white, ${Colors.PrimeWhite});
    }
  }
`;
const Checkbox = (_a) => {
  var { children, validationBehavior = "native" } = _a, props = __rest(_a, ["children", "validationBehavior"]);
  return jsx(Checkbox$1, Object.assign({ css: checkboxStyles, "data-zds": true, validationBehavior, "data-has-no-visible-label": React.Children.count(children) === 0 ? true : void 0 }, props), ({ isIndeterminate, isSelected }) => jsx(
    React.Fragment,
    null,
    jsx(
      "div",
      { className: "checkbox", "data-zds": true },
      jsx("svg", { viewBox: "0 0 18 18", "aria-hidden": "true", "data-zds": true }, isIndeterminate ? jsx("rect", { x: 0, y: 7, width: 18, height: 4 }) : isSelected && jsx("polyline", { points: "2 9 8 14 16 4" }))
    ),
    jsx("div", { className: "label" }, children)
  ));
};

export { Checkbox };
//# sourceMappingURL=Checkbox.es.js.map
